import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCabinet: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cabinet"><path d="M2.75 4.75V11.25H21.25V4.75H2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 5V11" stroke="currentColor" strokeWidth="1.5"/><path d="M5 11.5L3.75 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19 11.5L20.25 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCabinet;
